import {createRoot} from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import {initAnalytics} from '@/shared/utils/analytics.ts'
import {initMixpanel} from '@/shared/utils/mixpanel'
import {initOtel} from '@/shared/lib/otel/browser-otel'
import {ErrorBoundary} from '@/shared/components/ErrorBoundary'
import {initDatadog} from '@/shared/lib/datadog/datadog'
import {getDatadogConfig, isDatadogConfigured} from '@/shared/lib/datadog/config'

// Initialize OpenTelemetry (must be called before other initializations)
initOtel();

// Initialize Datadog (if configured)
if (isDatadogConfigured()) {
  const datadogConfig = getDatadogConfig();
  if (datadogConfig.clientToken) {
    initDatadog({
      clientToken: datadogConfig.clientToken,
      ...(datadogConfig.applicationId && { applicationId: datadogConfig.applicationId }),
      ...(datadogConfig.site && { site: datadogConfig.site }),
      ...(datadogConfig.service && { service: datadogConfig.service }),
      ...(datadogConfig.env && { env: datadogConfig.env }),
      ...(datadogConfig.version && { version: datadogConfig.version }),
      ...(datadogConfig.sampleRate && { sampleRate: datadogConfig.sampleRate }),
      ...(datadogConfig.enableRum && { enableRum: datadogConfig.enableRum }),
    });
  }
}

initAnalytics();
initMixpanel();

// Development helper removed - React DevTools detection is handled automatically

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
